if (typeof window === 'undefined') {
    throw new Error('translate.ts should not be imported in the service worker. Use serviceWorkerTranslate.ts instead.');
}
